const ProposalFundingStatusEnum = Object.freeze({
    AWAITING_FUNDS: 'AWAITING_FUNDS',
    FUNDS_AVAILABLE: 'FUNDS_AVAILABLE',
    FUNDS_TRANSFERRED: 'FUNDS_TRANSFERRED',
    FUNDS_CLEARED: 'FUNDS_CLEARED'
});

export default ProposalFundingStatusEnum;
